import { type AdvancingActivitySource, useAdvancingActivityQuery } from "./AdvancingActivityLog";
import { useInvalidateOnAdvancingActivity } from "./useInvalidateOnAdvancingActivity";

export const useAdvancingActivityCount = (source: AdvancingActivitySource, advancingSessionId: number) => {
  const { query } = useAdvancingActivityQuery(source);

  useInvalidateOnAdvancingActivity(advancingSessionId, source.queryKey);

  return query.data?.pages[0].pagination.total;
};
